const searchCondition = {
    getSearchParamList: function () {
        paramList = {};
        $(".js-search-element:checked").map(function () {
            const name = $(this).attr("name");

            if ($(this).val().length != 0) {
                if (paramList[name] === undefined) {
                    paramList[name] = [];
                }
                paramList[name].push($(this).val());
            }
        });

        // チェックボックスの処理
        $(".js-search-checkbox-element:checked").map(function () {
            const name = $(this).attr("name");
            if ($(this).val().length != 0) {
                if (paramList[name] === undefined) {
                    paramList[name] = [];
                }
                paramList[name].push($(this).val());
            }
        });

        // セレクトボックスの処理
        $(".js-search-selectbox-element").each(function () {
            const name = $(this).attr("name");
            const selectedOption = $(this).children("option:selected");
            if (selectedOption.val().length !== 0) {
                if (paramList[name] === undefined) {
                    paramList[name] = [];
                }
                paramList[name].push(selectedOption.val());
            }
        });

        // URLを生成する
        const tmpList = [];
        $.each(paramList, function (index, value) {
            if (tmpList[index] === undefined) {
                tmpList[index] = [];
            }
            tmpList.push(index + "_" + value.join("-"));
        });
        return tmpList.join("/");
    },

    // URLをキーワードなども含めて取得する。
    getSearchParamListWithKeyword: function (centerLatitude, centerLongitude, gps) {
        const searchConditionString = searchCondition.getSearchParamList();

        const getParams = [];
        const searchValue = $("#search").val();
        if (searchValue) {
            getParams.push("keyword=" + searchValue);
        }

        // 位置情報
        if (centerLatitude && centerLongitude) {
            getParams.push("centerLatitude=" + centerLatitude + "&centerLongitude=" + centerLongitude);
        }

        if (gps) {
            getParams.push("gpsOnFlg=true");
        }

        let params = getParams.join("&");
        if (params) {
            params = "?" + params;
        }

        return searchConditionString + params;
    },

    // 一覧表示のときなどに「中心位置」が決まっていない状態のときは距離の検索軸は無効にする。
    distanceEnable: function () {
        const latitude = $(".js-currentCenterLatitudeLongitude").data("latitude");
        const longitude = $(".js-currentCenterLatitudeLongitude").data("longitude");
        const keyword = $(".js-currentCenterLatitudeLongitude").data("keyword");

        let returnFlg = true;
        if ((latitude && longitude) || keyword) {
            // 有効に
            $(".js-distanceCondition").show();
        } else {
            // 無効に
            returnFlg = false;
            $(".js-distanceCondition").hide();
        }

        return returnFlg;
    }
};

window.searchCondition = searchCondition;
